import { Enum } from './enum';
export var BorderWidth = Enum({
  NONE: 'none',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  X_LARGE: 'xlarge'
});
export var BorderLocation = Enum({
  ALL: 'all',
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
});
export var BorderRadiusSize = Enum({
  NONE: 'none',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  FULL: 'full'
});
export var BorderRadiusLocation = Enum({
  ALL: 'all',
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_LEFT: 'bottom-left'
});
export function getBorderWidthClass(size) {
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BorderLocation.ALL;
  var formattedSize = '';
  var formattedLocation = '';
  switch (location) {
    case BorderLocation.TOP:
      formattedLocation = 't';
      break;
    case BorderLocation.RIGHT:
      formattedLocation = 'r';
      break;
    case BorderLocation.BOTTOM:
      formattedLocation = 'b';
      break;
    case BorderLocation.LEFT:
      formattedLocation = 'l';
      break;
  }
  switch (size) {
    case BorderWidth.NONE:
      formattedSize = '0';
      break;
    case BorderWidth.SMALL:
      formattedSize = '1';
      break;
    case BorderWidth.MEDIUM:
      formattedSize = '2';
      break;
    case BorderWidth.LARGE:
      formattedSize = '4';
      break;
    case BorderWidth.X_LARGE:
      formattedSize = '8';
      break;
  }
  return "border--".concat(formattedLocation).concat(!!formattedLocation ? '-' : '').concat(formattedSize);
}
export function getBorderColorClass(color) {
  return "border--".concat(color);
}
export function getBorderRadiusClass() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BorderWidth.MEDIUM;
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BorderRadiusLocation.ALL;
  var formattedSize = '';
  var formattedLocation = '';
  switch (location) {
    case BorderRadiusLocation.TOP:
      formattedLocation = 't';
      break;
    case BorderRadiusLocation.RIGHT:
      formattedLocation = 'r';
      break;
    case BorderRadiusLocation.BOTTOM:
      formattedLocation = 'b';
      break;
    case BorderRadiusLocation.LEFT:
      formattedLocation = 'l';
      break;
    case BorderRadiusLocation.TOP_LEFT:
      formattedLocation = 'tl';
      break;
    case BorderRadiusLocation.TOP_RIGHT:
      formattedLocation = 'tr';
      break;
    case BorderRadiusLocation.BOTTOM_LEFT:
      formattedLocation = 'bl';
      break;
    case BorderRadiusLocation.BOTTOM_RIGHT:
      formattedLocation = 'br';
      break;
  }
  switch (size) {
    case BorderRadiusSize.NONE:
      formattedSize = 'none';
      break;
    case BorderRadiusSize.SMALL:
      formattedSize = 'sm';
      break;
    case BorderRadiusSize.MEDIUM:
      formattedSize = 'md';
      break;
    case BorderRadiusSize.LARGE:
      formattedSize = 'lg';
      break;
    case BorderRadiusSize.FULL:
      formattedSize = 'full';
      break;
  }
  return "rounded--".concat(formattedLocation).concat(!!formattedLocation ? '-' : '').concat(formattedSize);
}